import { createContext, useContext, useState, useEffect } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import api from '../utils/api';

const AuthContext = createContext(null);

let msalInstance = null;

async function getMsalInstance() {
    if (msalInstance) return msalInstance;

    // Fetch Entra config from backend
    const { data } = await api.get('/auth/config');

    msalInstance = new PublicClientApplication({
        auth: {
            clientId:   data.client_id,
            authority:  data.authority,
            redirectUri: window.location.origin,
        },
        cache: {
            cacheLocation: 'sessionStorage',
        }
    });

    await msalInstance.initialize();
    return msalInstance;
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
    });

    async function login() {
        const msal = await getMsalInstance();

        // Pop up Microsoft login
        const result = await msal.loginPopup({
            scopes: ['User.Read']
        });

        // Send Microsoft token to our backend
        const { data } = await api.post('/auth/entra', {
            access_token: result.accessToken
        });

        localStorage.setItem('token', data.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    }

    function logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    }

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
